export default __webpack_public_path__ + "static/media/luxury-dining-room-lighting.59580c21.png";